export default "__VITE_ASSET__DbSiUpcF__"